import { SORTING_ORDER } from "enum/sorting.enum";
type SortOrderValue = `${SORTING_ORDER}`;
interface CompleteDateItem {
  est_complete_date: string;
}

export const undefinedToBottom = (a?: any, b?: any) => {
  if (a === undefined && b === undefined) {
    return 0;
  }

  // Undefined floats down to the bottom
  if (a === undefined) {
    return 1;
  }

  if (b === undefined) {
    return -1;
  }

  return 0;
};

export const byEstCompleteDate = (itemA: CompleteDateItem, itemB: CompleteDateItem) => {
  return new Date(itemA.est_complete_date).getTime() - new Date(itemB.est_complete_date).getTime();
};

interface StoresItem {
  user_store_count?: number;
}

export const byNumberOfStores = (itemA: StoresItem, itemB: StoresItem) => {
  const numberOfStoresA = itemA.user_store_count ? itemA.user_store_count : 0;
  const numberOfStoresB = itemB.user_store_count ? itemB.user_store_count : 0;

  return numberOfStoresA - numberOfStoresB;
};

const byAlpha = (stringA?: string, stringB?: string) => {
  const a = (stringA || "").toLocaleUpperCase();
  const b = (stringB || "").toLocaleUpperCase();

  if (a < b) {
    return -1;
  }

  if (a > b) {
    return 1;
  }

  return 0;
};

interface ProjectNameItem {
  project_name?: string;
}

export const byProjectName = (itemA: ProjectNameItem, itemB: ProjectNameItem) =>
  byAlpha(itemA.project_name, itemB.project_name);

interface ChainNameItem {
  chain?: { name?: string };
}

export const byChainName = (itemA: ChainNameItem, itemB: ChainNameItem) =>
  byAlpha(itemA.chain && itemA.chain.name, itemB.chain && itemB.chain.name);

export const sortStoreNumbersMixed = (a: string | number, b: string | number) => {
  const aValue = String(a ?? "").trim();
  const bValue = String(b ?? "").trim();
  const isNumeric = (value: string) => /^-?\d+(?:\.\d+)?$/.test(value);
  const aIsNumeric = isNumeric(aValue);
  const bIsNumeric = isNumeric(bValue);

  if (aIsNumeric && bIsNumeric) {
    const diff = Number(aValue) - Number(bValue);
    if (diff !== 0) return diff;
    return aValue.localeCompare(bValue, undefined, {
      numeric: true,
      sensitivity: "base",
    });
  }

  if (aIsNumeric && !bIsNumeric) return -1;
  if (!aIsNumeric && bIsNumeric) return 1;

  return aValue.localeCompare(bValue, undefined, { sensitivity: "base" });
};

export const sortRowsByStoreNumber = <T>(rows: T[], getStoreNumber: (row: T) => string | number, order: SortOrderValue = SORTING_ORDER.ASC) => {
  const sorted = [...rows].sort((a, b) =>
    sortStoreNumbersMixed(getStoreNumber(a) ?? "", getStoreNumber(b) ?? "")
  );
  return order === SORTING_ORDER.DESC ? sorted.reverse() : sorted;
};
